"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineBreak = exports.Charset = void 0;
var Charset;
(function (Charset) {
    Charset["UTF_8"] = "utf8";
    Charset["SHIFT_JIS"] = "sjis";
})(Charset = exports.Charset || (exports.Charset = {}));
var LineBreak;
(function (LineBreak) {
    LineBreak["LF"] = "LF";
    LineBreak["CRLF"] = "CRLF";
})(LineBreak = exports.LineBreak || (exports.LineBreak = {}));
